import Router from "next/router";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { profileApi } from "@entities/profile";
import { setAccessToken, setRefreshToken } from "@shared/lib/utils";
import { API } from "../authSlice";
import { hideRegistrationForm } from "../layoutSlice";

export const authByOAuthToken = createAsyncThunk<
    any,
    { platform: string; accessToken: string },
    { rejectValue: { message: string } }
>("auth/authByOAuthToken", async ({ platform, accessToken }, thunkAPI) => {
    try {
        const url = `${API}/v1/oauth/${platform}/tokens?accessToken=${accessToken}`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });

        let data = await response.json();

        if (response.status === 200) {
            const token = data?.data?.accessToken;
            const refreshToken = data?.data?.refreshToken;
            if (!token) {
                throw new Error("No token come from server");
            }
            setAccessToken(token);
            setRefreshToken(refreshToken);
            thunkAPI.dispatch(hideRegistrationForm());
            const profileQuery = profileApi.endpoints.getProfile.initiate({
                accessToken: token
            });
            const res = await thunkAPI.dispatch(profileQuery);

            localStorage.setItem("user", JSON.stringify(res.data));
            await Router.push("/");
            return {
                ...data,
                user: res.data
            };
        } else {
            const message =
                typeof data.data === "object" && !Array.isArray(data?.data)
                    ? data.data
                    : data?.message;
            return thunkAPI.rejectWithValue({
                message: message || "Something went wrong"
            });
        }
    } catch (e: any) {
        return thunkAPI.rejectWithValue({
            message: e.response.data || "Something went wrong"
        });
    }
});